// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.env-analyzer-container {
  padding: 20px 0;
  width: 100%;
  max-width: none;
  margin: 0;
}
.env-analyzer-container .env-analyzer-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.env-analyzer-container h1 {
  color: #2C7EA0;
  margin-bottom: 0;
  font-weight: 600;
}
.env-analyzer-container .analyzing-path-note {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 1rem;
}
.env-analyzer-container .tenant-path-highlight {
  display: inline-block;
  background-color: rgba(44, 126, 160, 0.12);
  color: #1d5a75;
  font-family: "SFMono-Regular", Consolas, monospace;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
}
.env-analyzer-container .synced-at-label {
  font-size: 0.9rem;
}
.env-analyzer-container .utc-note {
  font-size: 0.85rem;
  margin-bottom: 1rem;
}
.env-analyzer-container h4 {
  color: #2C7EA0;
  font-size: 1.2rem;
  font-weight: 600;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}
.env-analyzer-container h5 {
  color: #495057;
  font-weight: 600;
}
.env-analyzer-container .preset-buttons {
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
  padding-bottom: 0.4rem;
}
.env-analyzer-container .card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.env-analyzer-container .card .card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 1rem 1.25rem;
}
.env-analyzer-container .commit-card.commit-card-head {
  border-color: #4a3aa7;
  box-shadow: 0 0 0 1px #4a3aa7;
}
.env-analyzer-container .commit-message code {
  color: #212529;
  white-space: pre-wrap;
  word-break: break-word;
}
.env-analyzer-container .table {
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.env-analyzer-container .table th {
  background-color: #e9ecef;
  color: #495057;
  font-weight: 600;
  white-space: nowrap;
}
.env-analyzer-container .table td {
  vertical-align: middle;
}
.env-analyzer-container .env-analyzer-table .expandable-row {
  cursor: pointer;
}
.env-analyzer-container .env-analyzer-table .expand-toggle-cell {
  width: 2rem;
}
.env-analyzer-container .env-analyzer-table .expandable-row-detail td {
  background-color: #f8f9fa;
  padding: 1rem;
}
.env-analyzer-container .change-summary-list {
  margin: 0 0 0.75rem;
  padding-left: 1.25rem;
}
.env-analyzer-container .change-summary-list code {
  color: #212529;
  background: none;
  padding: 0;
}
.env-analyzer-container .diff-block {
  margin-bottom: 0.75rem;
}
.env-analyzer-container .diff-block:last-child {
  margin-bottom: 0;
}
.env-analyzer-container .diff-file-label {
  font-size: 0.8rem;
  color: #52514e;
  margin-bottom: 0.25rem;
}
.env-analyzer-container .diff-pre {
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 0.75rem;
  font-size: 0.8rem;
  max-height: 320px;
  overflow: auto;
  margin: 0;
}
.env-analyzer-container .diff-pre .diff-add {
  background-color: rgba(27, 175, 122, 0.12);
  color: #0a6b3c;
}
.env-analyzer-container .diff-pre .diff-remove {
  background-color: rgba(227, 73, 72, 0.12);
  color: #a12220;
}
.env-analyzer-container .diff-pre .diff-hunk {
  color: #898781;
  font-weight: 600;
}
.env-analyzer-container .daily-activity-chart .chart-legend {
  display: flex;
  gap: 1.25rem;
  margin-bottom: 0.5rem;
  font-size: 0.85rem;
  color: #52514e;
}
.env-analyzer-container .daily-activity-chart .legend-item {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}
.env-analyzer-container .daily-activity-chart .legend-swatch {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
}
.env-analyzer-container .daily-activity-chart .legend-swatch-new {
  background-color: #2a78d6;
}
.env-analyzer-container .daily-activity-chart .legend-swatch-existing {
  background-color: #eb6834;
}
.env-analyzer-container .daily-activity-chart .chart-scroll {
  position: relative;
  overflow-x: auto;
}
.env-analyzer-container .daily-activity-chart .chart-gridline {
  stroke: #e1e0d9;
  stroke-width: 1;
}
.env-analyzer-container .daily-activity-chart .chart-axis-label {
  fill: #898781;
  font-size: 10px;
}
.env-analyzer-container .daily-activity-chart .chart-bar-new {
  fill: #2a78d6;
}
.env-analyzer-container .daily-activity-chart .chart-bar-existing {
  fill: #eb6834;
}
.env-analyzer-container .daily-activity-chart .chart-bar-empty {
  fill: #e1e0d9;
}
.env-analyzer-container .daily-activity-chart .chart-bar-group {
  cursor: pointer;
}
.env-analyzer-container .daily-activity-chart .chart-tooltip {
  position: absolute;
  top: 0;
  right: 0;
  background: #212529;
  color: #fff;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  font-size: 0.8rem;
  pointer-events: none;
  max-width: 260px;
}`, "",{"version":3,"sources":["webpack://./frontend/sass/pages/env-analyzer.scss"],"names":[],"mappings":"AAQA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;AAPF;AASE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;AAPJ;AAUE;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;AARJ;AAWE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AATJ;AAYE;EACE,qBAAA;EACA,0CAAA;EACA,cAAA;EACA,kDAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AAVJ;AAaE;EACE,iBAAA;AAXJ;AAcE;EACE,kBAAA;EACA,mBAAA;AAZJ;AAeE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAbJ;AAgBE;EACE,cAAA;EACA,gBAAA;AAdJ;AAiBE;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;AAfJ;AAkBE;EACE,yBAAA;EACA,kBAAA;EACA,yCAAA;AAhBJ;AAkBI;EACE,yBAAA;EACA,gCAAA;EACA,qBAAA;AAhBN;AAoBE;EACE,qBAAA;EACA,6BAAA;AAlBJ;AAqBE;EACE,cAAA;EACA,qBAAA;EACA,sBAAA;AAnBJ;AAsBE;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;AApBJ;AAsBI;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AApBN;AAuBI;EACE,sBAAA;AArBN;AA0BI;EACE,eAAA;AAxBN;AA2BI;EACE,WAAA;AAzBN;AA4BI;EACE,yBAAA;EACA,aAAA;AA1BN;AA8BE;EACE,mBAAA;EACA,qBAAA;AA5BJ;AA8BI;EACE,cAAA;EACA,gBAAA;EACA,UAAA;AA5BN;AAgCE;EACE,sBAAA;AA9BJ;AAgCI;EACE,gBAAA;AA9BN;AAkCE;EACE,iBAAA;EACA,cApJ0B;EAqJ1B,sBAAA;AAhCJ;AAmCE;EACE,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AAjCJ;AAmCI;EACE,0CAAA;EACA,cAAA;AAjCN;AAoCI;EACE,yCAAA;EACA,cAAA;AAlCN;AAqCI;EACE,cA5KoB;EA6KpB,gBAAA;AAnCN;AAyCI;EACE,aAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAzLwB;AAkJ9B;AA0CI;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;AAxCN;AA2CI;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAzCN;AA4CI;EACE,yBA5MoB;AAkK1B;AA6CI;EACE,yBA/MyB;AAoK/B;AA8CI;EACE,kBAAA;EACA,gBAAA;AA5CN;AA+CI;EACE,eArNkB;EAsNlB,eAAA;AA7CN;AAgDI;EACE,aA3NoB;EA4NpB,eAAA;AA9CN;AAiDI;EACE,aAnOoB;AAoL1B;AAkDI;EACE,aAtOyB;AAsL/B;AAmDI;EACE,aAvOkB;AAsLxB;AAoDI;EACE,eAAA;AAlDN;AAqDI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;AAnDN","sourcesContent":["// Categorical palette validated via the dataviz skill's validator\n// (node scripts/validate_palette.js \"#2a78d6,#eb6834\" --mode light -> all pass).\n$env-analyzer-series-new: #2a78d6;\n$env-analyzer-series-existing: #eb6834;\n$env-analyzer-text-secondary: #52514e;\n$env-analyzer-text-muted: #898781;\n$env-analyzer-gridline: #e1e0d9;\n\n.env-analyzer-container {\n  padding: 20px 0;\n  width: 100%;\n  max-width: none;\n  margin: 0;\n\n  .env-analyzer-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  h1 {\n    color: #2C7EA0;\n    margin-bottom: 0;\n    font-weight: 600;\n  }\n\n  .analyzing-path-note {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    margin-bottom: 1rem;\n  }\n\n  .tenant-path-highlight {\n    display: inline-block;\n    background-color: rgba(44, 126, 160, 0.12);\n    color: #1d5a75;\n    font-family: 'SFMono-Regular', Consolas, monospace;\n    font-size: 0.85rem;\n    font-weight: 600;\n    padding: 0.15rem 0.5rem;\n    border-radius: 4px;\n  }\n\n  .synced-at-label {\n    font-size: 0.9rem;\n  }\n\n  .utc-note {\n    font-size: 0.85rem;\n    margin-bottom: 1rem;\n  }\n\n  h4 {\n    color: #2C7EA0;\n    font-size: 1.2rem;\n    font-weight: 600;\n    margin-top: 1.5rem;\n    margin-bottom: 1rem;\n  }\n\n  h5 {\n    color: #495057;\n    font-weight: 600;\n  }\n\n  .preset-buttons {\n    display: flex;\n    gap: 0.4rem;\n    flex-wrap: wrap;\n    padding-bottom: 0.4rem;\n  }\n\n  .card {\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n\n    .card-header {\n      background-color: #f8f9fa;\n      border-bottom: 1px solid #dee2e6;\n      padding: 1rem 1.25rem;\n    }\n  }\n\n  .commit-card.commit-card-head {\n    border-color: #4a3aa7;\n    box-shadow: 0 0 0 1px #4a3aa7;\n  }\n\n  .commit-message code {\n    color: #212529;\n    white-space: pre-wrap;\n    word-break: break-word;\n  }\n\n  .table {\n    background-color: #fff;\n    border-radius: 6px;\n    overflow: hidden;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n\n    th {\n      background-color: #e9ecef;\n      color: #495057;\n      font-weight: 600;\n      white-space: nowrap;\n    }\n\n    td {\n      vertical-align: middle;\n    }\n  }\n\n  .env-analyzer-table {\n    .expandable-row {\n      cursor: pointer;\n    }\n\n    .expand-toggle-cell {\n      width: 2rem;\n    }\n\n    .expandable-row-detail td {\n      background-color: #f8f9fa;\n      padding: 1rem;\n    }\n  }\n\n  .change-summary-list {\n    margin: 0 0 0.75rem;\n    padding-left: 1.25rem;\n\n    code {\n      color: #212529;\n      background: none;\n      padding: 0;\n    }\n  }\n\n  .diff-block {\n    margin-bottom: 0.75rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  .diff-file-label {\n    font-size: 0.8rem;\n    color: $env-analyzer-text-secondary;\n    margin-bottom: 0.25rem;\n  }\n\n  .diff-pre {\n    background-color: #fff;\n    border: 1px solid #dee2e6;\n    border-radius: 6px;\n    padding: 0.75rem;\n    font-size: 0.8rem;\n    max-height: 320px;\n    overflow: auto;\n    margin: 0;\n\n    .diff-add {\n      background-color: rgba(27, 175, 122, 0.12);\n      color: #0a6b3c;\n    }\n\n    .diff-remove {\n      background-color: rgba(227, 73, 72, 0.12);\n      color: #a12220;\n    }\n\n    .diff-hunk {\n      color: $env-analyzer-text-muted;\n      font-weight: 600;\n    }\n  }\n\n  // Daily activity chart\n  .daily-activity-chart {\n    .chart-legend {\n      display: flex;\n      gap: 1.25rem;\n      margin-bottom: 0.5rem;\n      font-size: 0.85rem;\n      color: $env-analyzer-text-secondary;\n    }\n\n    .legend-item {\n      display: inline-flex;\n      align-items: center;\n      gap: 0.4rem;\n    }\n\n    .legend-swatch {\n      display: inline-block;\n      width: 10px;\n      height: 10px;\n      border-radius: 2px;\n    }\n\n    .legend-swatch-new {\n      background-color: $env-analyzer-series-new;\n    }\n\n    .legend-swatch-existing {\n      background-color: $env-analyzer-series-existing;\n    }\n\n    .chart-scroll {\n      position: relative;\n      overflow-x: auto;\n    }\n\n    .chart-gridline {\n      stroke: $env-analyzer-gridline;\n      stroke-width: 1;\n    }\n\n    .chart-axis-label {\n      fill: $env-analyzer-text-muted;\n      font-size: 10px;\n    }\n\n    .chart-bar-new {\n      fill: $env-analyzer-series-new;\n    }\n\n    .chart-bar-existing {\n      fill: $env-analyzer-series-existing;\n    }\n\n    .chart-bar-empty {\n      fill: $env-analyzer-gridline;\n    }\n\n    .chart-bar-group {\n      cursor: pointer;\n    }\n\n    .chart-tooltip {\n      position: absolute;\n      top: 0;\n      right: 0;\n      background: #212529;\n      color: #fff;\n      padding: 0.5rem 0.75rem;\n      border-radius: 6px;\n      font-size: 0.8rem;\n      pointer-events: none;\n      max-width: 260px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
